<template>
  <div id="app" class="d-flex" style="height: 100vh;">
    <!-- Sidebar Component -->
    <Sidebar
      v-if="showSidebarComp"
      :is-visible="showSidebar"
      class="sidebar"
      :style="{ display: showSidebar ? 'block' : 'none' }"
    />

    <!-- Main content area -->
    <div :class="['main-content', { 'expanded': !showSidebar }]">
      <!-- Top Navbar -->
      <NavBar v-if="showNavbar" @toggle-sidebar="toggleSidebar" />

      <!-- Main content -->
      <div class="container-fluid p-3 content-area">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from './components/SideBar.vue';
import NavBar from './components/NavBar.vue';

export default {
  name: 'App',
  components: {
    Sidebar,
    NavBar,
  },
  data() {
    return {
      showSidebar: window.innerWidth >= 992, // Show sidebar by default on large screens
    };
  },
  computed: {
    showSidebarComp() {
      return this.$route.path !== '/login' && this.$route.path !== '/signup';
    },
    showNavbar() {
      return this.$route.path !== '/login' && this.$route.path !== '/signup';
    }
  },
  methods: {
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
    handleResize() {
      // Show sidebar if screen size is large (>= 992px), otherwise hide it
      this.showSidebar = window.innerWidth >= 992;
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped>
/* Ensures the sidebar is fixed and content scrolls */
#app {
  display: flex;
  height: 100vh; /* Full viewport height */
  overflow: hidden; /* Prevents the entire page from scrolling */
}

.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 250px; /* Adjust as needed */
  height: 100%;
  background-color: #f8f9fa;
  z-index: 10; /* Keeps the sidebar above other content */
  transition: transform 0.3s ease-in-out; /* Smooth transition when hiding the sidebar */
}

.main-content {
  margin-left: 250px; /* Match the width of the sidebar */
  width: 100%;
  overflow-y: auto; /* Allow scrolling within the main content */
  transition: margin-left 0.3s ease-in-out; /* Smooth transition when the sidebar is toggled */
}

.main-content.expanded {
  margin-left: 0; /* Remove margin when the sidebar is hidden */
}

.content-area {
  padding-top: 20px;
  height: calc(100vh - 56px); /* Subtract navbar height if needed */
  overflow-y: auto;
}
</style>
